<ng-template #appTitleTemplate >
  <div class="welcomeMsg">
    Welcome to Research Arsenal
  </div>
</ng-template>


<ng-template #appLinksSectionTemplate>
  <div class="btn-links">
    <app-slant-button [btnColor]="'green'" [chevronMode]="true" [btnIconClass]="'fa-user-circle'" tooltip="Sign up for Research Arsenal" [outlineMode]="false"
     (click)="createAccount()">
     Create account
    </app-slant-button>
    <br><br>
    <a class="btn btn-link ms-1" id="resetPwdBtn" matTooltip="Click here if you forgot your password"
     (click)="resetPassword()">
      Reset password
    </a>
  </div>
</ng-template>

<ng-template #resetPasswordModal>
  <div class="text-center">
    <i class="fas fa-exclamation-triangle text-warning fa-3x mb-3"></i>
  </div>
  <p class="mt-2">
    You have failed to log in <strong>{{ maxFailedAttempts }} times</strong> in a row.
  </p>
  <p>
    Would you like to reset your password for the email address <strong>{{ currentLoginEmail }}</strong>?
  </p>
</ng-template>

<ng-template #accountLockedModal>
  <div class="text-center">
    <i class="fas fa-lock text-warning fa-3x mb-3"></i>
  </div>
  <p class="mt-2">
    Your account has been temporarily locked due to multiple failed login attempts.
  </p>
  <p>
    You can either wait for the <b>lockout to expire</b>, or <b>reset your password</b>.
  </p>
  <p class="text-muted small">
    <i class="fas fa-info-circle me-1"></i>
    This security measure helps protect your account from unauthorized access attempts.
  </p>
</ng-template>

<ng-template #resendEmailModal>
  <p class="mt-2">
    You must confirm you email address before logging in.<br>
    Please check your email inbox or spam folder for a message from
     <strong>{{ emailFrom }}</strong> and click the link to finish your registration.
  </p>
  <hr>
  <p>
    If your email confirmation link has expired or you did not receive the account confirmation email, you can request another one below.
  </p>
  <label for="resendEmail" class="form-label">
    Enter the email address you registered with:
  </label>
  <input type="email" required name="resendEmail" placeholder="Your email address" class="form-control editable" [(ngModel)]="resendEmailAddress">
  <br>
</ng-template>

<div class='filler'>
  <h4 id="slogan">
    A premier Civil War database at your fingertips.
  </h4>
  
  <lib-login id="loginView" #loginView
  [appTitleTemplate]="appTitleTemplate"
  [componentBackgroundColor]="'rgba(0,0,0,0)'"
  [componentTextColor]="'rgba(255,255,255,1)'"
  [appLinksSectionTemplate]="appLinksSectionTemplate" (lockedOutEmitter)="handleLockedOut($event)"></lib-login>
  <!-- [appLoginButtonSectionTemplate]="defaultLoginButtonSectionTemplateMobile" -->

</div>

<app-site-footer></app-site-footer>

<lib-reset-password-wizard *ngIf="resetPwdMode"
  class="wizards" [ngClass]="{'mobile': isHandset}"
  [passwordScorerFn]="pwdScore"
  [minimumPwdScore]="appMinimumPwdScore"
  [minimumPwdLength]="appMinimumPwdLength"
  [triggerEmailFn]="triggerEmailOnServer"
  [changePwdServerFn]="changePassword"
  [outgoingEmailText]="emailFrom"
  [gotoPhase2]="phase2"
  [processResultSuccess]="resetPwdSuccess"
  (wizardCancelledEmitter)="cancelWizard()"
  (wizardCompletedEmitter)="cancelWizard()">
 <span class="small">
   <i class="fal fa-key-skeleton me-1"></i>
   Reset your password for the Research Arsenal
  </span>
</lib-reset-password-wizard>

<!-- <ng-template #defaultLoginButtonSectionTemplateMobile>
  <div class="loginContainerMobile">
    <button type="submit" class="btn btn-primary btn-lg loginButtonMobile"
      (click)="loginAttempt()">
      Log in
      <span class="slant"></span>
      <i class="fa" [ngClass]="{'fa-lock': !unlocked, 'fa-lock-open': unlocked}"></i>
    </button>
  </div>
</ng-template> -->